import store from 'store2';

const persistentStorage = store.session.namespace('VIEW_ALL_LOGS', true);

export default persistentStorage;
